import * as React from 'react'
import { bind } from 'classnames/bind'
import * as styles from '@procore/core-css/src/components/_checkbox.scss'

import { InputAttributes, Props } from '../utils/types'

export interface CheckboxProps extends Props {
  checked?: boolean
  className?: string
  disabled?: boolean
  indeterminate?: boolean
}

const cx = bind(styles)

const Checkbox = React.forwardRef<
  HTMLInputElement,
  InputAttributes & CheckboxProps
>(({ children, className, indeterminate = false, style, ...props }, ref) => (
  <label
    className={cx(
      'core-checkbox',
      {
        'core-checkbox--empty-label': !children,
      },
      className
    )}
    style={style}
  >
    <input
      {...props}
      ref={ref}
      className={cx('core-checkbox__input', {
        'core-checkbox__input--indeterminate': indeterminate,
      })}
      type="checkbox"
    />
    <p className={cx('core-checkbox__label')}>{children}</p>
  </label>
))

Checkbox.displayName = 'Checkbox'

export default Checkbox
